import {Component, HostBinding, Inject} from '@angular/core';
import {ScreenService} from './services/screen.service';
import {locale, loadMessages} from 'devextreme/localization';
import config from 'devextreme/core/config';
import * as moment from 'moment';
import 'moment/locale/fr';
// @ts-ignore
import frMessages from '../../../../node_modules/devextreme/localization/messages/fr.json';
import {DOCUMENT} from '@angular/common';
import {filter, take} from 'rxjs/operators';
import {animate, AnimationBuilder, style} from '@angular/animations';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  splashScreenElem: HTMLElement;

  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  constructor(
    private screen: ScreenService,
    @Inject(DOCUMENT) private document: Document,
    private animationBuilder: AnimationBuilder,
    private router: Router,
  ) {
    // Moment locale
    moment.locale('fr');

    // Devextreme Locale
    loadMessages(frMessages);
    locale('fr');

    // Devextreme config
    config({
      editorStylingMode: 'outlined',
    });


    // Hide the splash screen
    this.splashScreenElem = this.document.body.querySelector('#app-splash-screen');
    if (this.splashScreenElem) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        take(1)
      ).subscribe(() => this.hide());
    }

  }

  hide() {
    const player = this.animationBuilder.build([
      style({
        opacity: 1
      }),
      animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
        opacity: 0
      }))
    ]).create(this.splashScreenElem);

    player.onDone(() => this.splashScreenElem.remove());
    player.play();
  }
}
